import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-boton-general',
  templateUrl: './boton-general.component.html',
  styleUrls: ['./boton-general.component.scss']
})
export class BotonGeneralComponent implements OnInit {
  @ViewChild('boton') boton: ElementRef;
  @Output() execClick: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() texto: string;
  @Input() loading = false;
  @Input() tipo: string;
  @Input() size: string;
  @Input() classe: string;
  @Input() textLoading: string;
  @Input() ordenX: string;
  @Input() ordenY: string;
  @Input() padding: boolean;
  @Input() textoLoading = 'Cargando.';
  @Input() url = false;
  @Input() reload = false;
  @Input() srcUrl: string;
  @Input() color: string;
  @Input() icon: string;
  @Input() disabled: boolean;
  @Input() contraer = false;

  constructor(
    private router: Router
  ) { }

  ngAfterViewInit(): void {
    if (this.contraer === true) {
      this.cargando();
    }
  }

  ngOnInit(): void {
    //console.log(this.tipo)
  }

  emitClick = (): void => {
    if (this.url) {
      if (this.reload) {
        window.location.href = this.srcUrl;
      } else {
        this.router.navigate([this.srcUrl]);
      }
    } else {
      this.execClick.emit(true);
    }
  }

  private cargando = (): void => {
    if (this.loading) {
      this.boton.nativeElement.classList.add('boton-loading_contaer');
    } else {
      this.boton.nativeElement.classList.remove('boton-loading_contaer');
    }
  }
}
